import { Box, Typography } from "@mui/material";
import React from "react";
import Orangelogo from "../../assets/images/Orangelogo.png";
import Knowmorebtn from "../../components/button/Knowmorebtn";
import OfferingCard from "../../components/cards/OfferingCard";
import { offeringsData } from "../../data/whatWeOffer";

const Whatweoffer = () => {
  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "1440px" },
        margin: "0 auto",
        width: "100%",
        marginTop: "4rem",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 4rem" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "40%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "2rem", sm: "4rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            color: "rgba(35, 35, 37, 1)",
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.8rem",
          }}
        >
          WHAT WE OFFER
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "1.2rem",
          }}
        >
          Our <span style={{ color: "rgba(255, 102, 0, 1)" }}>Solutions</span>
        </Typography>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            marginTop: "1.2rem",
            marginBottom: "1.2rem",
          }}
        >
          Our solutions empower businesses to make informed decisions, optimize
          operations, and uncover new opportunities.
        </Typography>
        <Knowmorebtn content="Read more" link="/solutions" />
      </Box>
      <Box
        sx={{
          width: { xs: "100%", sm: "60%" },
          display: "flex",
          flexWrap: "wrap",
          justifyContent: { xs: "center", sm: "end" },
          gap: "1rem",
          marginTop: { xs: "2rem", sm: "0rem" },
        }}
      >
        {offeringsData.map((offering) => (
          <OfferingCard
            key={offering.id}
            icon={offering.icon}
            title={offering.title}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Whatweoffer;
